import { IJobListReportRequest, IReportRequest, IReportResponse } from "../models";
import FetchError from "./errors";
import { customFetch } from "./shared";

export const getReport = async (request: IReportRequest): Promise<IReportResponse | null> => {
  try {
    // Reports are still served by the legacy API host; the V2 host returns 404 for this route.
    const response = await customFetch(`/report/job`, {
      method: "POST",
      body: JSON.stringify(request)
    }, true, true)
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const getJobListReport = async (
  request: IJobListReportRequest
): Promise<IReportResponse | null> => {
  try {
    const response = await customFetch(`/report/jobs`, {
      method: "POST",
      body: JSON.stringify(request)
    }, true, true)
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};
